<template>
  <v-card class="rounded-card">
    <v-card-text>
      <v-row dense>
        <v-col cols="12" sm="6" md="7">
          <p class="mb-1">
              <span class="headline font-weight-bold text--primary">
                {{ aprovacao.fornecedor.pessoa.nome }}
              <px-popover-fornecedor
                :fornecedor-id="aprovacao.fornecedor.id" show-score/>
              </span>
            <px-situacao-aprovacao :situacao="aprovacao.situacao"/>
          </p>
        </v-col>
      </v-row>
      <p class="subtitle-card-detail mt-2">
        <v-icon>mdi-domain</v-icon>
        <px-fornecedor-documento :fornecedor="aprovacao.fornecedor"/>
      </p>
      <p class="subtitle-card-detail">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <v-icon>mdi-map-marker</v-icon>
              {{ endereco }}
            </span>
          </template>
          <span>Endereço do fornecedor</span>
        </v-tooltip>
      </p>
      <p class="subtitle-card-detail">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <v-icon>mdi-account</v-icon>
              {{ aprovacao.usuario.nome }}
            </span>
          </template>
          <span>Solicitante</span>
        </v-tooltip>
      </p>
      <p class="subtitle-card-detail" v-if="aprovacao.dataAprovacao">
        <span>
          <v-icon>mdi-calendar</v-icon>
          Aprovada em {{ aprovacao.dataAprovacao | date }}
        </span>
      </p>
      <p class="subtitle-card-detail" v-if="aprovacao.codigoInternoFornecedor">
        <v-icon>mdi-alpha-c-box-outline</v-icon>
        <px-span-tooltip
          bottom
          :text="aprovacao.codigoInternoFornecedor"
          tooltip="Código interno do fornecedor"/>
      </p>
      <div class="text--primary">
        <v-row dense>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Código</span>
            <div>
              {{ aprovacao.id }}
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Forma de pagamento</span>
            <div>
              <px-forma-pagamento :forma-pagamento="aprovacao.formaPagamento"
                                  :prazo-pagamento="aprovacao.prazoPagamento"/>
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Modo de pagamento</span>
            <div>
              {{ modoPagamento | naoInformado }}
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Observações internas</span>
            <div>
              <px-show-large-text :large-text="aprovacao.observacao"/>
            </div>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Tipo de frete</span>
            <div>
              {{ aprovacao.frete.tipoFrete }}
            </div>
          </v-col>
          <v-col cols="12" sm="3" v-if="aprovacao.dataPrevisaoEntrega">
            <span class="caption font-weight-bold">Previsão de entrega</span>
            <div>
              {{ aprovacao.dataPrevisaoEntrega | date }}
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Mensagem para o fornecedor</span>
            <div>
              <px-show-large-text :large-text="aprovacao.mensagem"/>
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Observação do frete</span>
            <div>
              <px-show-large-text :large-text="aprovacao.frete.observacaoFrete"/>
            </div>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Data de Faturamento</span>
            <div v-if="aprovacao.dataFaturamento">
              {{ aprovacao.dataFaturamento | date }}
            </div>
            <div v-else>
              Não Informado
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Finalidade da Compra</span>
            <div v-if="aprovacao.finalidadeCompra">
              <px-finalidade-compra-value :finalidade-compra="aprovacao.finalidadeCompra"/>
            </div>
            <div v-else>
              Não Informado
            </div>
          </v-col>
          <v-col cols="12" sm="3" v-if="aprovacao.dataNecessidadeEntregaSolicitacao">
            <span class="caption font-weight-bold">Data de entrega solicitante</span>
            <div>
              {{ aprovacao.dataNecessidadeEntregaSolicitacao | date }}
            </div>
          </v-col>
          <v-col cols="12" sm="3" v-if="aprovacao.saving > 0">
            <span class="caption font-weight-bold">Saving</span>
            <div>
              {{ aprovacao.saving | currency }}
            </div>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="3" v-if="aprovacao.projeto">
            <span class="caption font-weight-bold">Projeto</span>
            <div>
              {{ projeto | truncate(40) }}
            </div>
          </v-col>
          <v-col cols="12" sm="3" v-if="aprovacao.centroCusto">
            <span class="caption font-weight-bold">Centro de custo</span>
            <div>
              {{ centroCusto | truncate(40) }}
            </div>
          </v-col>
          <v-col cols="12" sm="3" v-if="aprovacao.tipoNotaEntrada">
            <span class="caption font-weight-bold">Tipo de nota de entrada</span>
            <div>
              <px-span-tooltip top
                               :text="notaEntrada"
                               :tooltip="aprovacao.tipoNotaEntrada.descricao"/>
            </div>
          </v-col>
          <v-col cols="12" sm="3" v-if="aprovacao.cfop">
            <span class="caption font-weight-bold">CFOP da compra</span>
            <div>
              <px-span-tooltip top
                               :text="cfop"
                               :tooltip="`${aprovacao.cfop.codigo} - ${aprovacao.cfop.descricao}`"/>
            </div>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Anexos</span>
            <div v-if="aprovacao.arquivos && aprovacao.arquivos.length">
              <px-anexo-chip :files="aprovacao.arquivos"
                             download-base-path="files/download-comprador"/>
            </div>
            <div v-else>
              Nenhum anexo informado
            </div>
          </v-col>
          <v-col cols="12" sm="3" v-if="isRecusada">
            <span class="error--text caption font-weight-bold">Motivo recusa</span>
            <div>
              <px-show-large-text :large-text="aprovacao.motivoRecusa"/>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-card-text>
    <px-confirm-dialog ref="confirm"/>
  </v-card>
</template>

<script>
import Vue from 'vue';
import { SituacaoAprovacao } from 'px-business-components';
import { descWithCodigoInterno } from '@/utils/object-utils';
import { computeEndereco } from '@/utils/endereco-utils';

export default {
  props: {
    aprovacao: {
      type: Object,
      required: true,
    },
  },
  computed: {
    modoPagamento() {
      return this.aprovacao.modoPagamento ? this.aprovacao.modoPagamento.descricao : null;
    },
    isRecusada() {
      return this.aprovacao.situacao === SituacaoAprovacao.keys.RECUSADO.key;
    },
    cfop() {
      return `${this.aprovacao.cfop.codigo} - ${Vue.filter('truncate')(this.aprovacao.cfop.descricao, 20)}`;
    },
    notaEntrada() {
      return Vue.filter('truncate')(this.aprovacao.tipoNotaEntrada.descricao, 20);
    },
    projeto() {
      return descWithCodigoInterno(this.aprovacao.projeto);
    },
    centroCusto() {
      return descWithCodigoInterno(this.aprovacao.centroCusto);
    },
    endereco() {
      return computeEndereco(this.aprovacao.fornecedor);
    },
  },
};
</script>
